import { api } from 'common';

import { ExportTextToBucketFormFields } from './FormFields';
import { exportTextToBucketDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const exportTextToBucketConfig: BlockConfigProps<api.FlowDefinition.ExportTextToBucketBlockConfig> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'exportData',
    defaultConfig: {
      patient: {
        sourceBlockName: '',
      },
      source: '',
    },
    configFields: {
      schema: api.FlowDefinition.ExportTextToBucketBlockConfigSchema,
      FormFields: ExportTextToBucketFormFields,
    },
    documentationMarkdown: exportTextToBucketDocumentationMarkdown,
  };
